<template>
	<div :class="getIconClass">
		<TooltipComponent
			direction="top"
			:tooltip="getTooltipText"
		>
			<template #showFromOutside>
				<i :class="getIcon"></i>
			</template>
		</TooltipComponent>
	</div>
</template>

<script>
	import TooltipComponent from '@core/components/TooltipComponent.vue';

	export default {
		name: 'InputTextbox',
		props: ['infoIconObj'],
		data() {
			return {
				defaultIcon: 'fas fa-info-circle',
			};
		},
		computed: {
			getIconClass() {
				return this.infoIconObj && this.infoIconObj.iconClass ? this.infoIconObj.iconClass : 'defaultIconClass';
			},
			getTooltipText() {
				return this.infoIconObj && this.infoIconObj.tooltipText ? this.infoIconObj.tooltipText : null;
			},
			getIcon() {
				// If the infoIconObj.icon is not set, use the default icon, but if we pass a property called noIcon, don't use the default icon
				// if (this.infoIconObj && this.infoIconObj.noIcon) {
				// 	return '';
				// }
				return this.infoIconObj && this.infoIconObj.icon ? this.infoIconObj.icon : this.defaultIcon;
			},
		},

		methods: {},
		components: {
			TooltipComponent,
		},
	};
</script>
<style>
	.defaultIconClass {
		color: var(--main-color);
	}
</style>
